
import { Heart, Star, Globe, Book } from "lucide-react";

const MissionStatement = () => {
  return (
    <section className="py-16 bg-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teedee-blue mb-4">Our Educational Mission</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Bobo & Teedee® is more than entertainment—it's a bridge connecting children to their cultural heritage while teaching universal values.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg">
            <div className="w-16 h-16 bg-teedee-blue/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <Heart className="h-8 w-8 text-teedee-blue" />
            </div>
            <h3 className="text-lg font-bold text-teedee-blue mb-3">Values Education</h3>
            <p className="text-gray-600 text-sm">
              Teaching kindness, respect, friendship, and empathy through engaging storylines.
            </p>
          </div>

          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg">
            <div className="w-16 h-16 bg-bobo-green/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <Globe className="h-8 w-8 text-bobo-green" />
            </div>
            <h3 className="text-lg font-bold text-bobo-green mb-3">Cultural Heritage</h3>
            <p className="text-gray-600 text-sm">
              Celebrating Cayman Islands culture, traditions, and natural beauty.
            </p>
          </div>

          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg">
            <div className="w-16 h-16 bg-brand-purple/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <Book className="h-8 w-8 text-brand-purple" />
            </div>
            <h3 className="text-lg font-bold text-brand-purple mb-3">Learning Fun</h3>
            <p className="text-gray-600 text-sm">
              Making education enjoyable through songs, stories, and interactive adventures.
            </p>
          </div>

          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg">
            <div className="w-16 h-16 bg-golden-orange/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <Star className="h-8 w-8 text-golden-orange" />
            </div>
            <h3 className="text-lg font-bold text-golden-orange mb-3">Character Building</h3>
            <p className="text-gray-600 text-sm">
              Developing strong moral character and positive life skills.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionStatement;
